import { defaultMargin } from "../insHorizontalBarChart/constants";
import { dataLabelFormatter } from "../insHorizontalBarChart/ins-horizontal-bar-chart-formatter";
import { getYAxisFormatter, xAxisFormatter } from "./utils";
import { useCurrentWidgetState, useWidgetComponentProps, useWidgetCurrentViewForm } from "components/widgets/hooks/use-current-widget";
import { useGetSelectedCurrency } from "components/workspaces/hooks/use-current-dashboard";
const WATERFALL_DEFAULT_MARGINS = { right: 15, top: 30 };
export const useGetWaterfallDatapointConfig = (props, queryState, series) => {
    const widgetProps = useWidgetComponentProps(props.sectionId, props.widgetId);
    const widgetState = useCurrentWidgetState(props.sectionId, props.widgetId);
    const currentViewForm = useWidgetCurrentViewForm(props.sectionId, props.widgetId);
    const selectedCurrency = useGetSelectedCurrency(), { inverted } = widgetProps;
    const { chartMargins } = widgetProps;
    const options = {
        chart: {
            className: `waterfallHighchart ${inverted ? "horizontal" : "vertical"}`,
            inverted,
            marginBottom: chartMargins?.bottom,
            marginLeft: inverted ? defaultMargin : undefined,
            marginRight: chartMargins?.right ?? WATERFALL_DEFAULT_MARGINS.right,
            marginTop: chartMargins?.top ?? WATERFALL_DEFAULT_MARGINS.top,
            plotShadow: false,
            showAxes: false,
            style: { fontFamily: "inherit" },
            styledMode: true,
            type: "waterfall"
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: widgetProps.showLegend
        },
        plotOptions: {
            waterfall: {
                animation: false
            }
        },
        series: [
            {
                borderWidth: 0,
                data: series,
                dataLabels: {
                    crop: false,
                    enabled: true,
                    formatter() {
                        return dataLabelFormatter(this, currentViewForm || widgetProps.valueFormat, widgetState?.displayValueType);
                    },
                    inside: false,
                    overflow: "allow",
                    useHTML: true
                },
                groupPadding: 0.08,
                lineWidth: 0,
                name: "value",
                pointPadding: 0,
                type: "waterfall"
            }
        ],
        title: {
            text: ""
        },
        tooltip: {},
        xAxis: {
            labels: {
                formatter: xAxisFormatter,
                useHTML: true
            },
            lineWidth: 0,
            min: 0,
            type: "category"
        },
        yAxis: {
            labels: {
                formatter: getYAxisFormatter(currentViewForm || widgetProps.valueFormat)
            },
            title: {
                text: null
            }
        }
    };
    return { colorSet: widgetProps.colorSet,
        currentViewForm,
        displayValueType: widgetState?.displayValueType,
        inverted,
        options,
        queryState,
        selectedCurrency,
        series,
        valueFormat: widgetProps?.valueFormat };
};
